import { colorPrimary, colorMain } from "components/styled-components/colors";
import {
  Thumb,
  Track,
  SliderContainer,
} from "components/styled-components/slider";
import { FC } from "react";
import { getTrackBackground, Range } from "react-range";

export interface BatterySliderProps {
  setBatteryLevel: (p: number[]) => void;
  batteryLevel: number[];
}

export const BatterySlider: FC<BatterySliderProps> = ({
  setBatteryLevel,
  batteryLevel,
}) => {
  return (
    <SliderContainer>
      <Range
        min={1}
        step={1}
        max={100}
        values={batteryLevel}
        onChange={(values_) => setBatteryLevel(values_)}
        renderTrack={({ props, children }) => (
          <Track
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values: batteryLevel,
                  colors: [colorMain, colorPrimary, "#ccc"],
                  min: 1,
                  max: 100,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </Track>
        )}
        renderThumb={({ props, index }) => (
          <Thumb {...props} bgColor={index ? colorPrimary : colorMain} />
        )}
      />
    </SliderContainer>
  );
};
export default BatterySlider;
